module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination is-small",
    attrs: {
      "role": "navigation",
      "aria-label": "pagination"
    }
  }, [(_vm.pageList.length > 0) ? _c('a', {
    staticClass: "pagination-previous",
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.current_page - 1)
      }
    }
  }, [_vm._v("Previous")]) : _vm._e(), _vm._v(" "), (_vm.pageList.length > 0) ? _c('a', {
    staticClass: "pagination-next",
    on: {
      "click": function($event) {
        return _vm.setPage(_vm.current_page + 1)
      }
    }
  }, [_vm._v("Next page")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination-page-length"
  }, [_vm._v("\n    Per Page:\n    "), _c('select', {
    attrs: {
      "name": "paginator-page-length"
    },
    on: {
      "change": function($event) {
        _vm.setPageLength(parseInt($event.target.value))
      }
    }
  }, _vm._l((_vm.pageLengthOptions), function(length) {
    return _c('option', {
      domProps: {
        "selected": _vm.page_length === length,
        "value": length
      }
    }, [_vm._v(_vm._s(length) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, _vm._l((_vm.pageList), function(page) {
    return _c('li', [(page.type === 'page') ? _c('a', {
      class: {
        'pagination-link': true,
        'is-current': page.isCurrent
      },
      attrs: {
        "aria-label": 'Goto page ' + page.number
      },
      on: {
        "click": function($event) {
          return _vm.setPage(page.number)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page.number) + "\n      ")]) : _c('span', {
      class: {
        'pagination-ellipsis': true
      }
    }, [_vm._v("…")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7bafd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/Paginator.vue
// module id = 532
// module chunks = 0